import { formatPrice } from '@ecom/helper-utils';
import { CurrencyCode } from '@/shared/constants/currencies';

/**
 * Membership price per supported currency, in major units.
 *
 * Typed against `CurrencyCode` rather than `string` so the table cannot drift from the
 * currencies the storefront actually sells in: adding a currency fails the build until
 * it is priced here. The visitor's currency is geo-derived and can only ever be one of
 * these seven, so the table no longer carries entries nothing can select (WTDEV-1709).
 */
export const MembershipPrices: Record<CurrencyCode, number> = {
  USD: 7.99,
  EUR: 7.99,
  GBP: 6.99,
  CAD: 10.99,
  AUD: 9.99,
  BRL: 25.99,
  MXN: 149,
};

export const getMembershipPrice = (currency: CurrencyCode, locale: string) => {
  return formatPrice(MembershipPrices[currency], currency, locale);
};
